import { Button, Typography, useMediaQuery, useTheme } from "@mui/material";
import Box from "@mui/material/Box";
import ArrowForward from "@mui/icons-material/ArrowForward";
import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";

gsap.registerPlugin(useGSAP);

const WebView = React.memo(({ container, rainContainerRef, containerRef }) => {
  return (
    <Box
      ref={containerRef}
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        backgroundImage: "url(/images/home/hero_bg.png)",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        height: "92.5vh",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          width: "90%",
          height: "70%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignContent: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            height: "60%",
            width: "60%",
            gap: 5,
          }}
        >
          <Typography
            className="hero-title"
            sx={{
              fontSize: {
                xs: "2.5rem",
                sm: "3.5rem",
                md: "3.5rem",
                lg: "4.5rem",
                xl: "6.5rem",
              },
            }}
            variant="h1"
          >
            <span
              style={{
                color: "#00B7FF",
              }}
            >
              I
            </span>
            nnovate first. <br />
            <span
              style={{
                color: "#00B7FF",
              }}
            >
              H
            </span>
            yper growth. <br />
            <span
              style={{
                color: "#00B7FF",
              }}
            >
              C
            </span>
            loud's are limit. <br />
          </Typography>
          <Typography
            className="hero-subtitle"
            sx={{
              pr: 10,
              color: "#fff",
              fontSize: {
                xs: "0.8rem",
                sm: "1rem",
                md: "1rem",
                laptop: "1.5rem",
              },
            }}
          >
            From cloud-powered SaaS to data-driven insights, we build scalable
            and future-ready solutions that transform businesses and fuel
            long-term growth
          </Typography>
          <Button
            className="hero-cta"
            type="submit"
            variant="outlined"
            endIcon={<ArrowForward />}
            href="https://calendar.app.google/yyQ665soutqZzj1H9"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              color: "rgba(255,255,255,0.95)",
              borderColor: "rgba(255,255,255,0.4)",
              px: 3,
              py: 1.25,
              maxWidth: 200,
              textTransform: "none",
              borderRadius: 1,
              "&:hover": { borderColor: "rgba(255,255,255,0.75)" },
            }}
          >
            Schedule a call
          </Button>
        </Box>
        <Box sx={{ width: "40%" }}></Box>
        <Box
          ref={container}
          className="hero-image"
          sx={{
            width: "40%",
            height: "100%",
            backgroundColor: "rbga(0,0,0,0.5)",
            top: 80,
            right: 0,
            position: "absolute",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignSelf: "flex-start",
              filter: "blur(2px)",
            }}
          >
            <img
              src="/images/home/hero_image.png"
              alt="hero_image"
              style={{
                width: "100%",
                maxHeight: "400px",
                height: "100%",
                zIndex: 2,
              }}
            />
          </Box>
          <Box
            ref={rainContainerRef}
            sx={{
              position: "absolute",
              top: 250,
              width: "100%",
              maxWidth: 350,
              height: "100%",
              overflow: "hidden",
              pointerEvents: "none",
              zIndex: 1,
            }}
          />
        </Box>
      </Box>
    </Box>
  );
});

const MobileView = React.memo(
  ({ container, rainContainerRef, containerRef }) => {
    return (
      <Box
        ref={containerRef}
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          backgroundImage: "url(/images/home/hero_bg.png)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          height: "80vh",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            width: "90%",
            height: "80%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignContent: "center",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              width: "80%",
              height: "55%",
              gap: 3,
            }}
          >
            <Typography
              sx={{
                fontSize: {
                  xs: "2.125rem",
                  sm: "3.0rem",
                  md: "3.2rem",
                  lg: "4.5rem",
                  xl: "5.25rem",
                },
                lineHeight: "50px",
              }}
              variant="h1"
            >
              <span
                style={{
                  color: "#00B7FF",
                }}
              >
                I
              </span>
              nnovate first. <br />
              <span
                style={{
                  color: "#00B7FF",
                }}
              >
                H
              </span>
              yper growth. <br />
              <span
                style={{
                  color: "#00B7FF",
                }}
              >
                C
              </span>
              loud's are limit. <br />
            </Typography>
            <Typography
              variant="subtitle1"
              sx={{
                color: "rgba(255, 255, 255, 0.6)",
                lineHeight: "20px",
                paddingRight: {
                  lg: 10,
                  xl: 15,
                },
                fontSize: {
                  xs: "0.875rem",
                  sm: "1rem",
                  md: "1rem",
                  laptop: "1.125rem",
                  lg: "1.225rem",
                },
              }}
            >
              From cloud-powered SaaS to data-driven insights, we build scalable
              and future-ready solutions that transform businesses and fuel
              long-term growth
            </Typography>
            <Button
              type="submit"
              variant="outlined"
              endIcon={<ArrowForward />}
              href="https://calendar.app.google/yyQ665soutqZzj1H9"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: "rgba(255,255,255,0.95)",
                borderColor: "rgba(255,255,255,0.4)",
                px: 3,
                py: 1.25,
                maxWidth: 200,
                textTransform: "none",
                borderRadius: 1,
                "&:hover": { borderColor: "rgba(255,255,255,0.75)" },
              }}
            >
              Schedule a call
            </Button>
          </Box>

          <Box
            ref={container}
            sx={{
              width: "55%",
              height: "100%",
              backgroundColor: "rbga(0,0,0,0.5)",
              top: 350,
              right: 0,
              position: "absolute",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignSelf: "flex-start",
                filter: "blur(2px)",
              }}
            >
              <img
                src="/images/home/hero_image.png"
                alt="hero_image"
                style={{
                  width: "100%",
                  maxHeight: "310px",
                  minWidth: 350,
                  height: "100%",
                  zIndex: 2,
                }}
              />
            </Box>
            <Box
              ref={rainContainerRef}
              sx={{
                position: "absolute",
                top: 170,
                width: "60%",
                height: "100%",
                overflow: "hidden",
                pointerEvents: "none",
                zIndex: 1,
              }}
            />
          </Box>
        </Box>
      </Box>
    );
  }
);

const HeroPage = () => {
  const theme = useTheme();
  const isMdScreen = useMediaQuery(theme.breakpoints.up("md"));

  const containerRef = useRef(null);
  const container = useRef();
  const rainContainerRef = useRef(null);

  useGSAP(() => {
    const tl = gsap.timeline({ defaults: { ease: "power2.out" } });

    tl.from(".hero-title", {
      opacity: 0,
      y: 20,
      duration: 0.8,
    })
      .from(
        ".hero-subtitle",
        {
          opacity: 0,
          y: 15,
          duration: 0.6,
        },
        "-=0.4"
      )
      .from(
        ".hero-cta",
        {
          opacity: 0,
          y: 10,
          duration: 0.5,
        },
        "-=0.3"
      )
      .from(
        ".hero-image",
        {
          opacity: 0,
          scale: 0.96,
          duration: 0.8,
        },
        "-=0.6"
      );
  }, []);

  const prefersReducedMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)"
  ).matches;

  useEffect(() => {
    const createDroplet = () => {
      const droplet = document.createElement("div");
      droplet.className = "binary-droplet";
      droplet.innerText = Math.random() > 0.5 ? "1" : "0";
      droplet.style.position = "absolute";
      droplet.style.left = `${Math.random() * 100}%`;
      droplet.style.color = "#999999";
      droplet.style.fontSize = `${Math.random() * 10 + 10}px`;
      droplet.style.opacity = 0.5;
      droplet.style.fontFamily = "monospace";

      rainContainerRef.current?.appendChild(droplet);

      gsap.to(droplet, {
        y: "+=800",
        duration: Math.random() * 6 + 2,
        ease: "none",
        onComplete: () => {
          if (rainContainerRef.current?.contains(droplet)) {
            rainContainerRef.current.removeChild(droplet);
          }
        },
      });
    };

    const interval = setInterval(() => {
      if (rainContainerRef.current) {
        createDroplet();
      }
    }, 50);

    return () => clearInterval(interval);
  }, [isMdScreen]);

  if (prefersReducedMotion) {
    gsap.set(".hero-title, .hero-subtitle, .hero-cta, .hero-image", {
      opacity: 1,
      y: 0,
      scale: 1,
    });
    return;
  }

  return isMdScreen ? (
    <WebView
      container={container}
      rainContainerRef={rainContainerRef}
      containerRef={containerRef}
    />
  ) : (
    <MobileView container={container} rainContainerRef={rainContainerRef} />
  );
};

export default HeroPage;
